// extracted by mini-css-extract-plugin
module.exports = {"contentInput":"search_contentInput__22KLP","input":"search_input__1no-m"};